import type { CurrentUser, OrganizationRole } from '../../types/roles';

export const onlyUnique = (value: string, index: number, self: string[]): boolean => {
  return self.indexOf(value) === index;
};

export const getIndependantProviderRoles = (currentUser: CurrentUser): OrganizationRole[] => {
  const organizationRolesIds = currentUser.userOrganizationRoles.map(
    orgRole => orgRole.role_id,
  );

  const inHouseProviderRoles = currentUser.userProviderRoles.filter(
    provRole => !organizationRolesIds.includes(provRole.role_id),
  );
  return inHouseProviderRoles;
};
